<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id
      }"
    />
    <RichContent v-if="readOnly || disabled" :content="valueOrPlaceholder" />
    <PageEditor
      v-else
      class="w-100 border p-2 rounded-5"
      :content="value || ''"
      :config="config"
      :iteration="iteration"
      @input="update"
    />
  </div>
</template>

<script>
import FormLabel from './FormLabel'
import FormMixin from './FormMixin'
import RichContent from '@/components/PageEditor/RichContent.vue'

export default {
  mixins: [ FormMixin ],
  components: {
    FormLabel,
    PageEditor: () => import('@/components/PageEditor/PageEditor'),
    RichContent,
  },
  props: {
    iteration: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    valueOrPlaceholder () {
      return this.value || '—'
    },
  },
}
</script>

<style scoped>
.form-element >>> .sticky-menubar {
  position: relative;
  top: 0;
  padding: 0px 0px 5px 0px;
  z-index: 1;
}
</style>
